import {NgModule} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeComponent} from '~/app/web/home/home.component';
import {DashboardComponent} from '~/app/web/dashboard/dashboard.component';
// @ts-ignore
import {AppAuthGuard, ChallengeComponent, ChallengeGuard} from 'mclane-webauth-lib';
import {SettingsComponent} from "mclane-apptemplate-lib";


const appRoutes: Routes = [
    {path: 'home', component: HomeComponent},
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {path: 'dashboard', component: DashboardComponent, canActivate: [AppAuthGuard, ChallengeGuard]},
    {path: 'challenge', component: ChallengeComponent, canActivate: [AppAuthGuard]},
    {
        path: 'settings',
        canActivate: [AppAuthGuard],
        component: SettingsComponent,
    },
    {
        path: '**',
        redirectTo: '/home',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
